export const ACTION_LIST_PRODUCTS = 'LIST_PRODUCTS';
export const ACTION_LOAD_DESIGNS = 'LOAD_DESIGNS';
export const ACTION_LOAD_FILTERS = 'LOAD_FILTERS';
export const ACTION_SEARCH_DESIGNS = 'SEARCH_DESIGNS';
export const ACTION_AWAIT_REQUEST = 'AWAIT_REQUEST';
